import protoRoot from "../proto-root";
import ActivityLogEvent from "src/modules/communication-protobuf/private/ActivityLogEvent";
import ActivityLogSession from "src/modules/communication-protobuf/private/ActivityLogSession";

const name = "activityLogRpcResponse";

function create({ inProgressEvent, session, nextUpdateNumber }) {
  const ActivityLogRpcResponse = protoRoot.lookupType(
    "comm.ActivityLogRpcResponse"
  );

  const response = ActivityLogRpcResponse.create({
    inProgressEvent: ActivityLogEvent.create(inProgressEvent),
    session: ActivityLogSession.create(session),
    nextUpdateNumber
  });

  return { payload: response, name };
}

export default {
  create,
  name
};

// message ActivityLogRpcResponse {
//     // Awake / sleeping event, that is currently in progress
//     ActivityLogEvent inProgressEvent = 1;

//     // Activity log with finished events (not with in progress one)
//     ActivityLogSession session = 2;

//     // next update number to be able to correctly check if we get all updates in ActivityLogEventUpdateMessage
//     int32 nextUpdateNumber = 3;
// }
